import { createAction } from 'redux-actions';

export const CAPTURE_TC = 'CAPTURE_TC';
export const CAPTURE_TC_SUCCESS = 'CAPTURE_TC_SUCCESS';
export const CAPTURE_TC_FAILED = 'CAPTURE_TC_FAILED';

export const captureTCAction = createAction(CAPTURE_TC);
export const captureTCSuccessAction = createAction(CAPTURE_TC_SUCCESS);
export const captureTCFailedAction = createAction(CAPTURE_TC_FAILED);